import { useState } from 'react';
import useInterval from 'use-interval';

export const updateEvery = (millis: number = 1000) => {
  function Wrapper<T>(Component: React.FC<T>) {
    return (props: T) => {
      const [count, setCount] = useState(0);

      useInterval(() => {
        setCount(count + 1);
      }, millis);

      return <Component {...props} />;
    };
  }

  return Wrapper;
};
